const Message = (() => {

    const ELEMENT_SELECTOR = '.js-message';
    const DELAY_TIME = 15000;

    class Message {
        /**
         * @param {HTMLElement} element
         */
        constructor(element) {
            this.element = element;
            this.timeout = null;
            this.element.addEventListener('click', this.remove.bind(this), false);
            this.removeAfterTime();
        }

        removeAfterTime() {
            this.timeout = window.setTimeout(this.remove.bind(this), DELAY_TIME);
        }

        remove() {
            window.clearTimeout(this.timeout);
            this.element.parentNode.removeChild(this.element);
        }
    }

    [].forEach.call(document.querySelectorAll(ELEMENT_SELECTOR), (item) => {
        new Message(item);
    });

    return Message;

})();

export default Message;